// import { useMemo, useState, useEffect } from "react";

// export function useSearch(data, query, keys, delay = 300) {
//   const [debouncedQuery, setDebouncedQuery] = useState(query);

//   // Debounce
//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedQuery(query);
//     }, delay);

//     return () => clearTimeout(handler);
//   }, [query, delay]);

//   return useMemo(() => {

//     if (debouncedQuery.trim()) {
//       const lowerQuery = debouncedQuery.trim().toLowerCase();
//       return data.filter((item) =>
//         keys.some((key) => {
//           const value = item[key];
//           if (value == null) return false;
//           return String(value).toLowerCase().includes(lowerQuery);
//         })
//       );
//     }

//     if (!debouncedQuery.trim()) {
//       return data;
//     }

//     const firstKey = keys[0];
//     const freqMap = {};

//     data.forEach((item) => {
//       const val = item[firstKey];
//       if (val != null) {
//         freqMap[val] = (freqMap[val] || 0) + 1;
//       }
//     });

//     let maxVal = null;
//     let maxCount = -1;
//     for (let val in freqMap) {
//       if (freqMap[val] > maxCount) {
//         maxVal = val;
//         maxCount = freqMap[val];
//       }
//     }

//     return data.filter((item) => item[firstKey] === maxVal);
//   }, [data, debouncedQuery, keys]);
// }

import { useMemo, useState, useEffect } from "react";

export function useSearch(data, query, keys, delay = 300) {
  const [debouncedQuery, setDebouncedQuery] = useState(query);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, delay);

    return () => clearTimeout(handler);
  }, [query, delay]);

  return useMemo(() => {
    if (!data || !Array.isArray(data)) return [];

    const q = debouncedQuery.trim().toLowerCase();

    if (!q) {
      return data;
    }

    return data.filter((item) =>
      keys.some((key) => {
        const value = item[key];
        if (value == null) return false;
        return String(value).toLowerCase().includes(q);
      })
    );
  }, [data, debouncedQuery, keys]);
}
